/** Indicator 语义色阶：样式层只认这些 tone */
export type IndicatorTone = 'success' | 'danger' | 'warning' | 'info' | 'default';

export interface IndicatorAppearance {
  tone: IndicatorTone;
  /** 是否建议闪烁（进行中状态） */
  flicker: boolean;
}

const TONES = new Set<string>(['success', 'danger', 'warning', 'info', 'default']);

/** 正向进行中 → 闪烁黄 */
const FORWARD_PROGRESS = new Set([
  'starting',
  'start',
  'pending',
  'waiting',
  'updating',
  'upgrading',
  'syncing',
  'building',
  'restarting',
  'restart',
  'containercreating',
  'reinstall',
  'in-review',
  'notrunning',
  'unfinished',
  'firing',
  'major',
  'released',
  'provisioning',
]);

/** 逆向进行中 → 闪烁红 */
const REVERSE_PROGRESS = new Set(['shuttingdown', 'stopping', 'stop', 'poweringoff', 'terminating', 'deleting', 'delete']);

const SUCCESS = new Set([
  'succeeded',
  'successful',
  'ready',
  'running',
  'jobrunning',
  'active',
  'normal',
  'bound',
  'available',
  'healthy',
  'ok',
  'working',
  'passed',
  'published',
]);

const DANGER = new Set([
  'failed',
  'error',
  'critical',
  'lost',
  'unschedulable',
  'crashloopbackoff',
  'imagepullbackoff',
  'rejected',
  'errupdated',
  'errcreated',
  'poweredoff',
  'deleted',
  'errorunschedulable',
]);

const INFO = new Set(['draft', 'pending-review', 'to-be-reviewed', 'creating']);

/**
 * 将业务状态名或语义 tone 解析为样式外观。
 * 调用方可直接传 tone（success/danger/warning/info/default），也可传业务状态由本函数映射。
 */
export function resolveIndicatorAppearance(status?: string): IndicatorAppearance {
  const key = (status || 'default').toLowerCase();

  if (TONES.has(key)) {
    // 语义色只决定颜色；是否闪烁由进行中业务状态或 flicker 属性控制
    return { tone: key as IndicatorTone, flicker: false };
  }

  if (key === 'unknown') {
    return { tone: 'default', flicker: false };
  }

  if (FORWARD_PROGRESS.has(key)) {
    return { tone: 'warning', flicker: true };
  }

  if (REVERSE_PROGRESS.has(key)) {
    return { tone: 'danger', flicker: true };
  }

  if (SUCCESS.has(key)) {
    return { tone: 'success', flicker: false };
  }

  if (DANGER.has(key)) {
    return { tone: 'danger', flicker: false };
  }

  if (INFO.has(key)) {
    return { tone: 'info', flicker: false };
  }

  return { tone: 'default', flicker: false };
}
